module.exports = __webpack_public_path__ + "static/media/invoice-data.2be96959.png";